import { useAuthStore } from '../stores/authStore';
import type { Permission } from '../types';

/**
 * Hook to check if the current user has a specific permission
 */
export const usePermission = (permission: Permission): boolean => {
  return useAuthStore((state) => state.permissions.includes(permission));
};

/**
 * Hook to check if the current user has any of the specified permissions
 */
export const useAnyPermission = (permissions: Permission[]): boolean => {
  return useAuthStore((state) =>
    permissions.some((permission) => state.permissions.includes(permission))
  );
};

/**
 * Hook to check if the current user has all of the specified permissions
 */
export const useAllPermissions = (permissions: Permission[]): boolean => {
  return useAuthStore((state) =>
    permissions.every((permission) => state.permissions.includes(permission))
  );
};

/**
 * Hook to get all permissions for the current user
 */
export const usePermissions = (): Permission[] => {
  return useAuthStore((state) => state.permissions);
};

/**
 * Hook to get the current user's role
 */
export const useRole = () => {
  return useAuthStore((state) => state.user?.role);
};
